import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../bootstrap/Button.jsx';
import styles from './AdvancedFilterWidget.module.scss';
import { setCrossDatasourceFilterModel, removeCrossDatasourceFilterModel } from '../../redux/datasourceSlice.js';

const ALIGNMENT = {
  'top-left': { alignItems: 'flex-start', justifyContent: 'flex-start' },
  'top-center': { alignItems: 'flex-start', justifyContent: 'center' },
  'top-right': { alignItems: 'flex-start', justifyContent: 'flex-end' },

  'center-left': { alignItems: 'center', justifyContent: 'flex-start' },
  center: { alignItems: 'center', justifyContent: 'center' },
  'center-right': { alignItems: 'center', justifyContent: 'flex-end' },

  'bottom-left': { alignItems: 'flex-end', justifyContent: 'flex-start' },
  'bottom-center': { alignItems: 'flex-end', justifyContent: 'center' },
  'bottom-right': { alignItems: 'flex-end', justifyContent: 'flex-end' },
};

function AdvancedFilterWidget({ widgetId }) {
  const dispatch = useDispatch();
  const [activeFilters, setActiveFilters] = useState([]);
  const buttons = useSelector((state) => state.dashboard.widgets[widgetId].settings?.buttons || []);
  const buttonSize = useSelector((state) => state.dashboard.widgets[widgetId].settings?.buttonSize || 'md');
  const buttonSpacing = useSelector((state) => state.dashboard.widgets[widgetId].settings?.buttonSpacing || 0);
  const buttonAlignment = useSelector((state) => state.dashboard.widgets[widgetId].settings?.buttonAlignment || 'center');
  const label = useSelector((state) => state.dashboard.widgets[widgetId].settings?.label || {});

  const groupFiltersByDatasource = (button) => {
    return (button.filters || []).reduce((acc, f) => {
      if (f.selectedDatasourceId) {
        acc[f.selectedDatasourceId] = acc[f.selectedDatasourceId] || [];
        if (f.advancedFilterModel) {
          acc[f.selectedDatasourceId].push(f.advancedFilterModel);
        }
      }
      return acc;
    }, {});
  };

  const applyFilter = (id) => {
    const button = buttons.find((b) => b.id === id);
    const filtersByDatasource = groupFiltersByDatasource(button || {});
    const filterId = `${widgetId}-${id}`;

    Object.entries(filtersByDatasource).forEach(([datasourceId, filterModels]) => {
      const filterModel = filterModels.length === 1
        ? filterModels[0]
        : { filterType: 'join', type: 'AND', conditions: filterModels };

      dispatch(setCrossDatasourceFilterModel({ datasourceId, filterId, filterModel }));
    });
  };

  const removeFilter = (id) => {
    dispatch(removeCrossDatasourceFilterModel({ filterId: `${widgetId}-${id}` }));
  };

  const toggleActiveFilters = (buttonId) => {
    const index = activeFilters.indexOf(buttonId);
    if (index === -1) {
      setActiveFilters([...activeFilters, buttonId]);
      applyFilter(buttonId);
    } else {
      setActiveFilters(activeFilters.filter((id) => id !== buttonId));
      removeFilter(buttonId);
    }
  };

  return (
    <div
      className={styles['filter-group-container']}
      style={{ ...(ALIGNMENT[buttonAlignment] || {}) }}
    >
      <div className={styles['btn-group-wrapper']}>
        {label.enabled && label.text && <label style={label}>
          {label.text}
        </label>}
        <div className='btn-group'>
          {buttons.map((button, i) => (
            <Button
              size={buttonSize}
              type=''
              onClick={() => toggleActiveFilters(button.id)}
              key={button.id}
              className={
                activeFilters.includes(button.id) ? styles['active-btn'] : styles['inactive-btn']
              }
              style={{
                ...(activeFilters.includes(button.id) ? { '--btn-primary-bg': button.color } : {}),
                ...(i !== 0 ? { marginLeft: buttonSpacing } : {}),
              }}
            >
              {button.name || I18n.t('unnamed')}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdvancedFilterWidget;
